import { extend } from "webdriver-js-extender";

//import { Customer } from "../customer/customer-model";
//import { AdminOrderDetail } from "./create-purchase-order.model";
//import { AdminOrder } from "./create-purchase-order.model";

//export class PurchaseOrderDetailView {
//  public vendor: Customer;
//  public orderDetails: AdminOrderDetail[];
//  public order: AdminOrder;
//  public mainCountry: string;
//  public mainState: string;
//}

export class PurchaseOrderDetailView {
  public id: string;
  public orderStatusName: string;
  public pOTotal: number;
  public poDate: Date;
  public purchaseOrderId: number;
  public products: POProducts[];
  public vendor: POVendor; 
  public orderStatus: number;

}

export class POProducts { 
  public orderNumber: number;
  public name: string; 
  public unitBalance: number;
  public imagePath: string;
  public quantity: number;
  public unitPrice: number;
  public url: string;
  public productSku: string;
  public unitComission: number;
  public productArrtibuteFields: string;
  public productArrtibuteValue: string;
}

export class POVendor { 
  public vendorName: string;
  public phoneNumber: string;
  public shopName: string;
  public address: string;
  public city: string;
  public state: string;
  public country: string;
}





export class SinglePOReport {
  public dateFrom: string;
  public dateTo: string;
  public purchaseOrderId: number;
  public orderId: string;
  public total: number;
  public vendor: POVendor;
}
export class MultiPOReport {
  public dateFrom: string;
  public dateTo: string;
  public venodors: DefaultReportCommon;
}
export class DefaultReportCommon {
  public total: number;
  public vendor: POVendor;
}



// WEBPACK FOOTER //
// ./src/app/models/PurchaseOrder/purchase-order-detail-view.model.ts